import React from 'react';
import Box from '@mui/material/Box';
import InfoIcon from '@mui/icons-material/Info';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/Error';
import {themeColors} from '../../theme/Theme';

type PromptProps = {
  variant: 'info' | 'warning' | 'error';
  title: React.ReactNode;
  content: React.ReactNode;
  icon?: React.ReactNode;
};

const backgroundColorMap: Record<PromptProps['variant'], string> = {
  info: themeColors.greyLight,
  warning: themeColors.lightYellow,
  error: themeColors.lightAlert,
};

const defaultIcons: Record<PromptProps['variant'], React.ReactNode> = {
  info: <InfoIcon />,
  warning: <WarningAmberIcon />,
  error: <ErrorIcon />,
};

export const Prompt: React.FC<PromptProps> = ({variant, title, content, icon}) => {
  const backgroundColor = backgroundColorMap[variant];
  const IconComponent = icon || defaultIcons[variant];

  return (
    <Box
      sx={{
        flex: 1,
        p: 2,
        borderRadius: 2,
        backgroundColor,
        gap: 1,
      }}
    >
      <Box sx={{display: 'flex', alignItems: 'center', mb: 1}}>
        <Box sx={{display: 'flex', alignItems: 'center', mr: 1}}>{IconComponent}</Box>
        <Box sx={{fontWeight: 'bold'}}>{title}</Box>
      </Box>
      <>{content}</>
    </Box>
  );
};
